function store(key, value) {
  if (typeof value === "object") value = JSON.stringify(value);
  if (typeof window !== "undefined") localStorage.setItem(key, value);
}

/* function get(key) {
    let data;
    if (typeof window !== "undefined") data = localStorage.getItem(key);
    else data = "";

    if (!data) return "";
    try {
        data = JSON.parse(data);
    } catch (e) {
        data = data;
    }
    return data;
} */
function get(key) {
  let data = "";

  if (typeof window !== "undefined") {
    const storedData = localStorage.getItem(key);
    if (storedData) {
      try {
        data = JSON.parse(storedData);
      } catch (e) {
        // If parsing fails, keep the original storedData
        data = storedData;
      }
    }
  }

  return data;
}

const clear = function () {
  localStorage.clear();
};

function remove(key) {
  localStorage.removeItem(key);
}

export default {
  store,
  get,
  remove,
  clear,
};
